import type { ReactElement } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { MY_QUOTES_PAGE_PARAM, myQuotesPath } from '@/shared/config';
import { SitePageShell } from '@/shared/ui';
import { MyPageHeader } from '@/widgets/my-page-header';
import { MyPageNav } from '@/widgets/my-page-nav';
import { MyQuoteList } from '@/widgets/my-quote-list';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

const POSITIVE_INTEGER = /^[1-9]\d*$/;

/** ?page= 가 양의 정수가 아니면 첫 페이지로 본다. */
const parsePage = (raw: string | null): number =>
  raw !== null && POSITIVE_INTEGER.test(raw) && Number.isSafeInteger(Number(raw)) ? Number(raw) : 1;

/**
 * 마이페이지 내 견적 목록(/my/quotes, 견적 설계 §7-1·§12).
 * 큰 "My Page" 머리 아래에 왼쪽(좁은 화면은 위) 메뉴와 견적 목록을 놓는다.
 */
export const MyQuotesPage = (): ReactElement => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const page = parsePage(params.get(MY_QUOTES_PAGE_PARAM));

  return (
    <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
      <MyPageHeader />
      <div className="mt-8 grid gap-10 sm:mt-12 lg:grid-cols-[13rem_minmax(0,1fr)] lg:gap-16 xl:grid-cols-[15rem_minmax(0,1fr)] xl:gap-20">
        <MyPageNav activeId="quotes" />
        <MyQuoteList
          page={page}
          onPageChange={(next) => {
            void navigate(myQuotesPath({ page: next }));
          }}
        />
      </div>
    </SitePageShell>
  );
};
